module.exports = __webpack_public_path__ + "static/default_post_img-ed530d4a9d4b653cd89a6a4667349908.png";